// Components
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
// Common
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import plansFields from '../../../fields/plansFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import ICONS from '@/common-utils/enums/icons';
import RouteUrls from '@/app/root/enums/RouteUrls';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsPlan } from '@/app/i18n/namespaces';

export const columnsPlansId = 'plans';

export const columnsPlans = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsPlansId, headerPackage.singleSelection),
        generateColumnDefByField({
            field: plansFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ planId: row.original.uuid }}
                    baseUrl={RouteUrls.PLAN_DETAILS.url}
                    requiredPermissions={[Permissions.SUBSCRIPTION_PLAN_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity entity={getObjectAttributeFromStringKey(cell.row.original, generateNestedFieldAccessor(plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL))} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.LABEL,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <div>
                    {cell.row.original[generateNestedFieldAccessor(plansFields.LABEL)]}
                    {
                        cell.row.original[plansFields.SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS.key] ?
                            <div className='text-xs flex text-success items-center'>
                                <Icon icon={ICONS.DEFAULT_PLAN} />
                                <Entity
                                    entity='keys.auto_activate_short'
                                    namespace={nsPlan}
                                    className='text-success'
                                />
                            </div>
                            :
                            false
                    }
                </div>
            )
        }),
        generateColumnDefByField({
            field: plansFields.PRODUCT_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity entity={cell.getValue(plansFields.PRODUCT_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(plansFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(plansFields.UPDATED_AT.key)} />
            )
        })
    ]).filter(col => !!col);
};